
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 18 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C93","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10 16a8.018 8.018 0 0 1-7.59-5.464l1.09-.364a6.868 6.868 0 0 0 6.5 4.68A6.86 6.86 0 0 0 16.852 8 6.86 6.86 0 0 0 10 1.148 6.86 6.86 0 0 0 3.148 8H2c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"}}),_c('path',{attrs:{"d":"M12.337 10 9 7.135V2h1.048v4.606L13 9.139zM4 7 2 9 0 7z"}})])])
          )
        }
      }
    